"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StackStyleEntry = exports.SingleStyleEntry = exports.CompositeStyleEntry = void 0;
exports.styleEntryForProp = styleEntryForProp;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _remeda = require("remeda");
class StackStyleEntry {
  constructor(prop, value) {
    (0, _defineProperty2.default)(this, "isDefault", false);
    (0, _defineProperty2.default)(this, "value", void 0);
    this.prop = prop;
    if (!value) {
      this.isDefault = true;
      this.value = {
        property: prop.property,
        type: "stack",
        values: []
      };
    } else {
      this.value = (0, _remeda.clone)(value);
    }
  }
  clone(value) {
    return new StackStyleEntry(this.prop, (0, _remeda.clone)(this.value));
  }
  update(update) {
    if (update.updates) {
      let index = update.index;
      if (update.push) {
        index = this.value.values.length;
        this.value.values.push([]);
      } else if (!this.value.values[index]) {
        this.value.values.splice(index, 0, []);
      }
      for (let it of update.updates) {
        let values = this.value.values[index] || [];
        for (let i = 0; i < this.prop.properties.length; i++) {
          let prop = this.prop.properties[i];
          if (!values[i]) {
            var _prop$fixedValues;
            if (prop.default && (_prop$fixedValues = prop.fixedValues) !== null && _prop$fixedValues !== void 0 && _prop$fixedValues.includes(prop.default)) {
              values.push({
                fixedValue: prop.default,
                value: "",
                unit: null
              });
            } else {
              var _prop$units;
              values.push({
                value: prop.default,
                unit: (_prop$units = prop.units) === null || _prop$units === void 0 ? void 0 : _prop$units[0],
                fixedValue: null
              });
            }
          }
          if (prop.property === it.property) {
            values.splice(i, 1, it);
          }
        }
      }
    }
  }
}
exports.StackStyleEntry = StackStyleEntry;
class CompositeStyleEntry {
  constructor(prop, value) {
    (0, _defineProperty2.default)(this, "isDefault", false);
    (0, _defineProperty2.default)(this, "value", void 0);
    this.prop = prop;
    if (!value) {
      this.isDefault = true;
      this.value = {
        property: prop.property,
        type: "composite",
        values: []
      };
    } else {
      this.value = (0, _remeda.clone)(value);
    }
  }
  clone(value) {
    return undefined;
  }
  update(update) {
    for (let it of update) {
      let values = this.value.values;
      for (let i = 0; i < this.prop.properties.length; i++) {
        let prop = this.prop.properties[i];
        if (!values[i]) {
          var _prop$fixedValues2;
          if (prop.default && (_prop$fixedValues2 = prop.fixedValues) !== null && _prop$fixedValues2 !== void 0 && _prop$fixedValues2.includes(prop.default)) {
            values.push({
              fixedValue: prop.default,
              value: "",
              unit: null
            });
          } else {
            var _prop$units2;
            values.push({
              value: prop.default,
              unit: (_prop$units2 = prop.units) === null || _prop$units2 === void 0 ? void 0 : _prop$units2[0],
              fixedValue: null
            });
          }
        }
        if (prop.property === it.property) {
          values.splice(i, 1, it);
        }
      }
    }
  }
  updateAll(update) {
    this.value.values = [];
    for (let it of this.prop.properties) {
      this.value.values.push((0, _remeda.clone)(update));
    }
  }
}
exports.CompositeStyleEntry = CompositeStyleEntry;
class SingleStyleEntry {
  constructor(prop, value) {
    (0, _defineProperty2.default)(this, "value", void 0);
    (0, _defineProperty2.default)(this, "isDefault", false);
    this.prop = prop;
    if (!value || !value.fixedValue && value.value === undefined) {
      var _prop$fixedValues3;
      this.value = {
        property: prop.property,
        type: prop.type
      };
      if (prop.default && (_prop$fixedValues3 = prop.fixedValues) !== null && _prop$fixedValues3 !== void 0 && _prop$fixedValues3.includes(prop.default)) {
        this.value.fixedValue = prop.default;
        this.value.value = "";
        this.value.unit = null;
      } else {
        var _prop$units3;
        this.value.fixedValue = null;
        this.value.value = prop.default;
        this.value.unit = (_prop$units3 = prop.units) === null || _prop$units3 === void 0 ? void 0 : _prop$units3[0];
      }
      this.isDefault = true;
    } else {
      this.value = (0, _remeda.clone)(value);
    }
  }
  clone(value) {
    return new SingleStyleEntry(this.prop, Object.assign({}, this.value, value));
  }
  update(update) {
    this.isDefault = false;
    if (update.unit !== undefined && update.unit !== this.value.unit) {
      var _this$prop$fixedValue;
      if (update.unit && (_this$prop$fixedValue = this.prop.fixedValues) !== null && _this$prop$fixedValue !== void 0 && _this$prop$fixedValue.includes(update.unit)) {
        this.value.fixedValue = update.unit;
        this.value.unit = null;
        this.value.value = "";
        return;
      }
      this.value.unit = update.unit;
      this.value.fixedValue = null;
      if (update.unit && this.prop.unitDefaults && !this.value.value) {
        if (typeof this.prop.unitDefaults === "string") {
          this.value.value = this.prop.unitDefaults;
        } else if (this.prop.unitDefaults[update.unit]) {
          this.value.value = this.prop.unitDefaults[update.unit];
        }
      }
    }
    if (update.value !== undefined && update.value !== this.value.value) {
      this.value.value = update.value;
      if (this.value.fixedValue) {
        var _this$prop$units;
        this.value.fixedValue = null;
        this.value.unit = (_this$prop$units = this.prop.units) === null || _this$prop$units === void 0 ? void 0 : _this$prop$units[0];
      }
    }
    if (update.fixedValue !== undefined && update.fixedValue !== this.value.fixedValue) {
      this.value.fixedValue = update.fixedValue;
      if (update.fixedValue) {
        this.value.unit = null;
        this.value.value = "";
      }
    }
  }
}
exports.SingleStyleEntry = SingleStyleEntry;
function styleEntryForProp(prop, value) {
  if (prop.type === "stack") {
    return new StackStyleEntry(prop, value);
  } else if (prop.type === "composite") {
    return new CompositeStyleEntry(prop, value);
  } else {
    return new SingleStyleEntry(prop, value);
  }
}
//# sourceMappingURL=StyleEntry.js.map